// extracted by mini-css-extract-plugin
export default {"items":"Templates_items__kXQXH","header":"Templates_header__B6z0v","textarea":"Templates_textarea__Mnvqu"};